import { render, staticRenderFns } from "./ProjectDiagram.vue?vue&type=template&id=21d400aa&"
import script from "./ProjectDiagram.vue?vue&type=script&lang=js&"
export * from "./ProjectDiagram.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDiagram.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/saas-tool/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21d400aa')) {
      api.createRecord('21d400aa', component.options)
    } else {
      api.reload('21d400aa', component.options)
    }
    module.hot.accept("./ProjectDiagram.vue?vue&type=template&id=21d400aa&", function () {
      api.rerender('21d400aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ProjectDiagram.vue"
export default component.exports